module.exports = __webpack_public_path__ + "static/img/international_model_h5.f75abe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/international_model_h5.png
// module id = 9jce
// module chunks = 34